<template>
  <div>
    <b-container class="services">
      <div style="padding: 60px 0" v-for="item in data" :key="item.id">
        <b-row>
          <b-col sm="12" class="mb">
            <h2 class="styled-title">{{ item.title }}</h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="5">
            <img :src="item.imageURL" alt="item.title" style="width: 100%" />
          </b-col>
          <b-col sm="7">
            <div v-html="item.description"></div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>

<script>
import { db } from "../firebase/db";
export default {
  data() {
    return {
      drawer: true,
      buttonName: "Know More",
      data: [],
      url: this.$route.params.id
    };
  },
  methods: {
    // Get data
    getData() {
      db.collection("services")
        .where("route", "==", this.url)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.data.push(doc.data());
            this.fetching = false;
          });
        });
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped></style>
